// frontend/src/components/EdaAnalysis/EdaWarnings.tsx

import React from 'react';

interface Props {
  warnings: any;
}

export const EdaWarnings: React.FC<Props> = ({ warnings }) => {
  const items = Array.isArray(warnings) ? warnings : [];

  if (items.length === 0) {
    return (
      <div className="section-card">
        <h3>⚠️ Alertas Científicos</h3>
        <div style={{
          padding: '16px',
          textAlign: 'center',
          color: '#66bb6a',
          background: 'rgba(102, 187, 106, 0.05)',
          borderRadius: '8px',
          border: '1px solid #66bb6a'
        }}>
          ✅ Nenhum alerta registrado.
        </div>
      </div>
    );
  }

  return (
    <div className="section-card">
      <h3>⚠️ Alertas Científicos</h3>
      {items.map((warning: any, index: number) => (
        <div
          key={index}
          style={{
            padding: '12px 16px',
            background: 'rgba(255, 193, 7, 0.1)',
            borderRadius: '8px',
            border: '1px solid #ffc107',
            marginBottom: '8px',
            color: '#e0e0e0',
          }}
        >
          <pre style={{ margin: 0, whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '13px' }}>
            {JSON.stringify(warning, null, 2)}
          </pre>
        </div>
      ))}
    </div>
  );
};